import { Injectable } from '@angular/core';
import { DefaultGlobalConfig, GlobalConfig, ToastrService } from 'ngx-toastr';
import { CustomToastComponent } from '../custom-toast/custom-toast.component';


@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  //#region Private Variables
  private toastConfig: Partial<GlobalConfig> = {
    ...DefaultGlobalConfig,
    toastComponent:  CustomToastComponent,
    closeButton:     true,
    enableHtml:      true,
    positionClass:   'toast-bottom-right',
    timeOut:         4000,
    extendedTimeOut: 1000,
    tapToDismiss:    true,
  };
  //#endregion

  //#region Constructor
  constructor(private toastr: ToastrService) {}
  //#endregion

  //#region Public Methods

  public showError(message: string, callback?: () => void): void {
    this.toastr.error(message, '', this.toastConfig).onHidden.subscribe(() => callback?.());
  }

  public showSuccess(message: string, callback?: () => void): void {
    this.toastr.success(message, '', this.toastConfig).onHidden.subscribe(() => callback?.());
  }

  public showInfo(message: string, callback?: () => void): void {
    this.toastr.info(message, '', this.toastConfig).onHidden.subscribe(() => callback?.());
  }

  public showWarning(message: string, callback?: () => void): void {
    this.toastr.warning(message, '', this.toastConfig).onHidden.subscribe(() => callback?.());
  }

  //#endregion
}